/* eslint-disable no-undef */
import React from 'react';
import { Styles } from './styles';

interface InfoCardProps {
  iconSrc: string;
  label: string;
  value: string | number;
}

const InfoCard: React.FC<InfoCardProps> = ({ iconSrc, label, value }) => {
  return (
    <Styles.DetailsBox>
      <Styles.DetailsIcon src={iconSrc} />
      <Styles.DetailsText>{label}</Styles.DetailsText>
      <Styles.DetailsText>{value}</Styles.DetailsText>
    </Styles.DetailsBox>
  );
};

export default InfoCard;
